import React from 'react';

import { ContextProps, StorageConsumer } from './storage-context';

export type WithStorageProps = ContextProps;

export default function <BaseComponentProps extends WithStorageProps>(
    BaseComponent: React.ComponentType<BaseComponentProps>
) {
    type HocProps = BaseComponentProps;

    // return HOC with injected props
    return React.forwardRef((props: HocProps, ref) => (
        <StorageConsumer>
            {(storageProps) => <BaseComponent {...props} {...storageProps} ref={ref} />}
        </StorageConsumer>
    ));
}
